import { create } from 'zustand';

export enum Steps {
  Company = '',
  Directors = 'directors',
  Shareholders = 'shareholders',
  Members = 'members',
  Business = 'business',
  Completed = 'completed'
}

interface RegisteringState {
  step?: Steps;
  setStep: (user: Steps) => void;
  update: boolean;
  forceUpdate: () => void;
}

const useRegisteringStore = create<RegisteringState>((set) => ({
  setStep: (step) => set(() => ({ step: step })),
  update: false,
  forceUpdate: () => set((state) => ({ update: !state.update }))
}));

export { useRegisteringStore };
